import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { passwordLengthValidator, passwordsMatchValidator } from 'src/app/shared/validators';
import { KeyValuePair } from '../../../shared/models/key-value-pair';
import { Roles } from '../../auth.service';
import { LearnerInvite } from '../models/learner-invite';
import { LearnerRegistration } from '../models/learner-registration';

@Component({
  selector: 'app-learner-portal-registration-form',
  templateUrl: './learner-portal-registration-form.component.html',
  styleUrls: ['./learner-portal-registration-form.component.scss'],
  standalone: false,
})
export class LearnerPortalRegistrationFormComponent implements OnInit {
  @Input() invite: LearnerInvite;
  @Input() registerError: string;
  @Output() submitted = new EventEmitter<LearnerRegistration>();
  formGroup: UntypedFormGroup;
  accessPreferences: KeyValuePair[] = [
    new KeyValuePair(
      Roles.LearnerEdit,
      'I opt to register for interactive access, which includes the ability to sign documents electronically.'
    ),
    new KeyValuePair(
      Roles.LearnerReadOnly,
      'I opt to register for view only access, without the ability to sign documents electronically.'
    ),
  ];
  inputType: 'text' | 'password' = 'password';
  inputTypePassCopy: 'text' | 'password' = 'password';

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initializeFormGroup();
    this.formGroup.patchValue({
      invitationId: this.invite.id,
      email: this.invite.email,
    });
  }

  initializeFormGroup() {
    this.formGroup = this.fb.group(
      {
        invitationId: ['', { validators: [Validators.required] }],
        firstName: ['', { validators: [Validators.required] }],
        lastName: ['', { validators: [Validators.required] }],
        dateOfBirth: ['', { validators: [Validators.required] }],
        email: ['', { validators: [Validators.required] }],
        password: ['', { validators: [Validators.required, passwordLengthValidator], updateOn: 'change' }],
        confirmedPassword: ['', { validators: [Validators.required], updateOn: 'change' }],
        consentAccepted: [false, { validators: [Validators.requiredTrue] }],
      },
      {
        validators: passwordsMatchValidator,
      }
    );
    if (this.invite.rightsHaveTransferred) {
      this.formGroup.addControl('accessPreference', new UntypedFormControl('', Validators.required));
    }
  }

  onSubmit() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      this.submitted.emit(this.formGroup.value);
    }
  }

  onRevealOrHide(isVisible: boolean) {
    if (isVisible) this.inputType = 'text';
    else this.inputType = 'password';
  }

  onRevealOrHideCopy(isVisible: boolean) {
    if (isVisible) this.inputTypePassCopy = 'text';
    else this.inputTypePassCopy = 'password';
  }
}
